import {MODULE_ACTIONS} from "../actions/types";
import {updateCache} from "ith-redux-helpers";
import {UPDATE_MODULES} from "../actions";
import {uniqify} from "ah-lib";

const defaultState = {
	list: [],
	houses: {}
	
};
export default (state = defaultState, {type, modules, all, house_id, house_list}) => {
	switch (type) {
		case MODULE_ACTIONS.SET:
			if (all) {
				return {
					...state,
					list: modules,
					...updateCache(UPDATE_MODULES)
				};
			}
			return {
				...state,
				list: uniqify(state.list, modules)(module => module.module_id),
				...updateCache(UPDATE_MODULES)
			};
		case MODULE_ACTIONS.SET_HOUSE:
			return {
				...state,
				houses: {
					...state.houses,
					[house_id]: uniqify(state.houses[house_id], house_list)(m2h => m2h.module_id)
				}
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/moduleReducer.js